import type { Theme } from "@mui/material";

export const autocompleteTextFieldSx = (theme: Theme, inputHeight?: number) => ({
  "& .MuiOutlinedInput-root": {
    ...(inputHeight && { height: inputHeight, minHeight: inputHeight }),
    "& fieldset": {
      borderColor: theme.palette.strokeColor.primary,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.text.secondary,
    },
    "&.Mui-disabled, &.Mui-disabled:hover": {
      "& fieldset": {
        borderColor: theme.palette.strokeColor.primary,
      },
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-error fieldset": {
      borderColor: theme.palette.error.main,
    },
  },
  "& .MuiInputBase-input::placeholder": {
    color: theme.palette.text.placeholder,
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    opacity: 1,
  },
  "& textarea::placeholder": {
    color: theme.palette.text.placeholder,
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    opacity: 1,
  },
});

export const autocompleteMenuItemSx = (theme: Theme) => ({
  "display": "flex",
  "alignItems": "center",
  "minWidth": 0,
  "&.MuiAutocomplete-option.Mui-focused, &.MuiAutocomplete-option.Mui-focusVisible, &.MuiMenuItem-root:hover":
    {
      backgroundColor: theme.palette.action.selected,
      color: theme.palette.text.primary,
    },
});
